import React from 'react'
import HomeNav from '../Navbars/HomeNav'

import premiumpack from '../Plans/PlanImages/WhatsApp Image 2025-08-05 at 16.26.58_feee62bc.jpg'

export default function PremiumPack() {
  return (
    <div className=''>

      <div className=''>
      <img className='' src={premiumpack} alt="" />
      </div>
      
    </div>
  )
}
